// Import modules
import $ from 'jquery';
import modalModule from './modules/modal';
import carouselModule from './modules/carousel';
import appModule from './modules/app';
import VideoPlayerWrapper from './videoPlayer';
import 'lazysizes';
import starModule from './modules/star';
import smoothScrollModule from './modules/smoothScroll';
import stickyHeaderModule from './modules/stickyHeader';
import weightFilterModule from './modules/weightFilter';
import appBannerModule from './modules/appBanner';
import { animateValue } from './utils';
import articlesModule from './modules/articles';
import GoogleAnalytics from './googleAnalytics';
import productFilterModule from './modules/productFilter';
import Accordion from './accordion';
import Form from './form';
import VideoPlayerJW from './videoPlayerJW';

import searchModule from './modules/search';
import globalNotificationModule from './modules/globalNotification';
import sortModule from './modules/sort';
import selectBoxModule from './modules/selectbox';
import pointshopModule from './modules/pointshop';
import 'jquery-ui/themes/base/core.css';
import calendarModule from './modules/calendar';
import resendEmailModule from './modules/resendEmail';
import onboardingModule from './modules/onboarding';
import OverlayCookie from './overlayCookie';
import footerModule from './modules/footer';
import productReviewsModule from './modules/productReviews';
import faqModule from './modules/faq';
import reviewProductModule from './modules/reviewProduct';

// require('tridion.web.video/dist/VideoPlayer');
// require('tridion.web.video/jwplayer/jwplayer');

require('matchmedia-polyfill');
require('matchmedia-polyfill/matchMedia.addListener');

// JWPlayer license key
// window.jwplayer.key = 'mldk2Rhilj6ksd3y9SF+84b0gpZIkAhpmTRVNcROkds=';
// Expose jQuery as global for Klarna
window.$ = $;
window.jQuery = $;

const accordion = new Accordion();
accordion.init();
const form = new Form();

window.addEventListener('oneTrustCategoriesInit', () => {
  if (document.readyState === 'complete') {
    VideoPlayerWrapper.initVideo(true);
  } else {
    window.addEventListener('load', () => {
      VideoPlayerWrapper.initVideo(true);
    });
  }
});

// Attach VideoPlayer globaly for YT videos
window.YTVideoPlayer = VideoPlayerWrapper;

const app = appModule();
if (app) {
  app.then((event) => {
    event.init();
  });
}

const overlayCookie = new OverlayCookie();
if (overlayCookie) {
  overlayCookie.init();
}

window.onload = () => {
  form.init();

  // Close sidebar when user click on overlay
  $('.sidebar__overlay').on('mousedown', (event) => {
    if (event.target.classList.contains('sidebar__overlay')) {
      $('body').removeClass('no-scroll');
      $(event.target).closest('.sidebar').removeClass('opened');
    }
  });

  // Media bank videos, timeout is for VueJS side to not overlap execution
  setTimeout(() => {
    VideoPlayerWrapper.initVideo();
  }, 1000);
  const coinElement = document.getElementById('animate-coins');
  if (coinElement) {
    const endValue = parseInt(coinElement.dataset.coinValue, 10);
    animateValue(coinElement, 0, endValue, 3000);
  }

  const modal = modalModule();
  if (modal) {
    modal.then((event) => {
      event.init();
    });
  }

  const star = starModule();
  if (star) {
    star.then((event) => {
      event.init();
    });
  }

  const smoothScroll = smoothScrollModule();
  if (smoothScroll) {
    smoothScroll.then((event) => {
      event.init();
    });
  }

  const stickyHeader = stickyHeaderModule();
  if (stickyHeader) {
    stickyHeader.then((event) => {
      event.init();
    });
  }

  const weightFilter = weightFilterModule();
  if (weightFilter) {
    weightFilter.then((event) => {
      event.init();
    });
  }

  const appBanner = appBannerModule();
  if (appBanner) {
    appBanner.then((event) => {
      event.init();
    });
  }

  const articles = articlesModule();
  if (articles) {
    articles.then((event) => {
      event.init();
    });
  }

  const productFilter = productFilterModule();
  if (productFilter) {
    productFilter.then((event) => {
      event.init();
    });
  }

  const search = searchModule();
  if (search) {
    search.then((event) => {
      event.init();
    });
  }

  const globalNotification = globalNotificationModule();
  if (globalNotification) {
    globalNotification.then((event) => {
      event.init();
    });
  }

  const sort = sortModule();
  if (sort) {
    sort.then((event) => {
      event.init();
    });
  }

  const selectBox = selectBoxModule();
  if (selectBox) {
    selectBox.then((event) => {
      event.init();
    });
  }

  const gaSetup = new GoogleAnalytics();
  gaSetup.init();

  const jwPlayerSetup = new VideoPlayerJW();
  jwPlayerSetup.init();

  const pointshop = pointshopModule();
  if (pointshop) {
    pointshop.then((event) => {
      event.init();
    });
  }

  const calendar = calendarModule();
  if (calendar) {
    calendar.then((event) => {
      event.init();
    });
  }

  const resendEmail = resendEmailModule();
  if (resendEmail) {
    resendEmail.then((event) => {
      event.init();
    });
  }

  const onboarding = onboardingModule();
  if (onboarding) {
    onboarding.then((event) => {
      event.init();
    });
  }

  const carousel = carouselModule();
  if (carousel) {
    carousel.then((event) => {
      event.init();
    });
  }

  const footer = footerModule();
  if (footer) {
    footer.then((event) => {
      event.init();
    });
  }

  const productReviews = productReviewsModule();
  if (productReviews) {
    productReviews.then((event) => {
      event.init();
    });
  }

  const reviewProduct = reviewProductModule();
  if (reviewProduct) {
    reviewProduct.then((event) => {
      event.init();
    });
  }

  const faq = faqModule();
  if (faq) {
    faq.then((event) => {
      event.init();
    });
  }

  // Close calendar once user clicks outside of datepicker
  $(document).on('click', (e) => {
    const target = $(e.target);
    if (
      !target.is('.ui-datepicker')
      && !target.parents().is('.selector-for-datepicker')
      && !target.is('.js-datepicker')
      && !target.is('.ui-datepicker-year')
      && !target.is('.ui-datepicker-month')
    ) {
      // Check if datepicker js is loaded
      if (typeof $('.js-datepicker').datepicker === 'function') {
        $('.js-datepicker').datepicker('hide');
      }
    }
  });

  // hotspot tabs
  $(
    '.diaper__hotspot__container .hotspot__range__buttons  a:first-child',
  ).addClass('active_hotspot');
  $(
    '.diaper__hotspot__container .diaper__hotspot_wrapper .diaper__blocks__content',
  ).removeClass('active_hotspot_content');
  $(
    '.diaper__hotspot__container .diaper__hotspot_wrapper .diaper__blocks__content:first',
  ).addClass('active_hotspot_content');
  $('.hotspot__range__buttons a').on('click', (event) => {
    event.preventDefault();
    $('.hotspot__range__buttons a').removeClass('active_hotspot');
    $(event.target).addClass('active_hotspot');
    $(
      '.diaper__hotspot__container .diaper__hotspot_wrapper .diaper__blocks__content',
    ).removeClass('active_hotspot_content');

    $($(event.target).attr('href')).addClass('active_hotspot_content');
  });
};
